import type { Environment } from '@change-corgi/config/environments';

import __optimizely from '../config/optimizely.json';

export const optimizelyProjectIds = __optimizely as Readonly<Record<Environment, string>>;
